"use client"

import { FC, useCallback } from "react"
import { useContent } from "@/src/context/ContentContext"
import { useLanguage } from "@/src/context/LanguageContext"
import { useUI } from "@/src/lib/i18n/ui"

const Hero: FC = () => {
  const { hero } = useContent()
  const { lang } = useLanguage()
  const t = useUI(lang)

  const scrollToSection = useCallback((sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 100
      window.scrollTo({ top: y, behavior: "smooth" })
    }
  }, [])

  return (
    <section
      id="hero"
      style={{
        backgroundImage: "url('/icons/background.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="min-h-screen py-8 bg-gradient-to-br from-gray-900 via-black to-gray-800 relative overflow-hidden flex items-center"
    >
      <div className="container mx-auto pt-20 lg:pt-32 pb-16 relative z-10">
        <div className="max-w-4xl h-full">
          <h1 className="text-4xl lg:text-4xl xl:text-4xl font-bold text-white mb-8 leading-tight">
            {hero.title}
          </h1>
          <div className="mb-8 !font-light">
            <p className="text-lg lg:text-xl text-gray-300 mb-6 leading-relaxed">
              {hero.description}
            </p>
            <div className="text-gray-300 space-y-2">
              <p className="mb-4">
                {t("heroIntro")}{" "}
                <span className="text-white !font-semibold">{t("heroIntroHighlight")}</span>
                {t("heroIntroSuffix")}
              </p>
              <ul className="space-y-2 text-base lg:text-lg">
                {hero.bullets.map((bullet, i) => (
                  <li key={i} className="flex items-start">
                    <span className="text-white mr-2">•</span>
                    {bullet}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollToSection("pricing")}
              className="px-8 py-3 bg-transparent border border-white text-white rounded-full hover:bg-white hover:text-black transition-all duration-300 text-lg font-light"
            >
              {t("heroBtnPrice")}
            </button>
            <button
              onClick={() => scrollToSection("contact-title")}
              className="px-8 py-3 bg-transparent border border-white text-white rounded-full hover:bg-white hover:text-black transition-all duration-300 text-lg font-light"
            >
              {t("heroBtnContacts")}
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
